import { useState } from "react";
import { Container, Row } from "react-bootstrap";
import { useBackEndVersionQuery } from "../redux/slice/api/staticData";
import ModalPrintable from "./modalPrintable/ModalPrintable";

function CpntFooterBO(): JSX.Element {
  const _date = new Date();
  const { data, isLoading } = useBackEndVersionQuery();
  const [showModalPrintable, setShowModalPrintable] = useState(false);
  // const [showModalMentionLegale, setModalMentionLegale] = useState(false);
  const [modalTitle, setmodalTitle] = useState("");
  const [modalContent, setModalContent] = useState<JSX.Element>();
  const [showPrintButton, setshowPrintButton] = useState(true);

  const handleVersion = () => {
    setshowPrintButton(false);
    setShowModalPrintable(true);
    setmodalTitle(process.env.REACT_APP_WEBSITE_TITLE ?? "");
    setModalContent(
      <>
        <div>
          <b>Mode : </b>
          {process.env.REACT_APP_MODE}
        </div>
        <div>
          <b>Front : </b>
          ver.{process.env.REACT_APP_VERSION}
        </div>
        <div>
          <b>Back : </b>
          ver.{isLoading ? "?" : data?.Return_Value}
        </div>
      </>
    );
  };

  return (
    <>
      <footer className="App-footer">
           <Container>
           <Row>    
        <p className="text-center ">
        Copyright{" "}
  <span onClick={() => handleVersion()}>©</span>{" "}
  2024
  {_date?.getFullYear() > 2024 ? ` - ${_date.getFullYear()}` : ""} - Electre
        </p>
        </Row>
        </Container>
      </footer>
      {/* <ToastContainer theme="dark" position="bottom-center" autoClose={2000} /> 
      toastStyle={{ backgroundColor: "#ccc" }} */}
      {showModalPrintable && (
        <ModalPrintable
          handleClose={() => setShowModalPrintable(false)}
          show={showModalPrintable}
          headerText={modalTitle}
          printbutton={showPrintButton}
          modalsize="xl"
        >
            {modalContent !== undefined ? (
                <div>{modalContent}</div>
            ) : (
                <div>Contenu non défini</div>
            )}
        </ModalPrintable>
      )}
      </>
  );
}

export default CpntFooterBO;
